var map = {
	"./noble01/进场特效@2x.png": "0933",
	"./noble02/进场特效@2x.png": "87b4",
	"./noble03/进场特效@2x.png": "836d",
	"./noble04/进场特效@2x.png": "b54d",
	"./noble05/进场特效@2x.png": "f948"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17a3";